import CHEVRON_ARROW from "@assets/quick-news/Chevron_left_grey.svg";
import { QNCardType } from "@typings/QuickNews";
import { ReactElement, useCallback } from "react";
import { twMerge } from "tailwind-merge";

type QNSideNavProps = {
  activeTab: QNCardType;
  setActiveTab: (tab: QNCardType) => void;
};

const NAV_BUTTON_STYLES = {
  base: "group hidden md:flex fixed top-1/2 -translate-y-1/2 z-40 items-center justify-center text-white-100 font-bold text-2sm",
  label:
    "opacity-0 group-hover:opacity-100 transition-opacity duration-300 mt-0.5",
} as const;

type SideNavButtonProps = {
  tab: QNCardType;
  isActive: boolean;
  onClick: () => void;
  position: "left" | "right";
};

const SideNavButton = ({
  tab,
  isActive,
  onClick,
  position,
}: SideNavButtonProps) => {
  const isLeft = position === "left";

  return (
    <button
      aria-label={`Switch to ${tab}`}
      onClick={onClick}
      className={twMerge(
        NAV_BUTTON_STYLES.base,
        isLeft ? "left-2 lg:left-4" : "right-2 lg:right-4",
        isActive && "!hidden",
      )}
    >
      <span
        className={`inline-flex items-center ${!isLeft ? "flex-row-reverse" : ""}`}
      >
        <img
          height={40}
          width={40}
          className={`block p-1 ${!isLeft ? "rotate-180" : ""}`}
          alt={`Switch to ${tab}`}
          src={CHEVRON_ARROW}
        />
        <span className={NAV_BUTTON_STYLES.label}>{tab}</span>
      </span>
    </button>
  );
};

export default function QnSideNav({
  activeTab,
  setActiveTab,
}: QNSideNavProps): ReactElement {
  const handleMyFeedClick = useCallback(() => {
    setActiveTab("MyFeed");
  }, [setActiveTab]);

  const handleVideosClick = useCallback(() => {
    setActiveTab("Videos");
  }, [setActiveTab]);

  return (
    <>
      <SideNavButton
        tab="MyFeed"
        isActive={activeTab === "MyFeed"}
        onClick={handleMyFeedClick}
        position="left"
      />
      <SideNavButton
        tab="Videos"
        isActive={activeTab === "Videos"}
        onClick={handleVideosClick}
        position="right"
      />
    </>
  );
}
